<template>
  <div class="big">
    <div class="page_title">项目订单列表</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              index="1"
              style="font-size:16px"
            >全部</el-menu-item>
            <el-menu-item
              index="2"
              style="font-size:16px"
            >未支付</el-menu-item>
            <el-menu-item
              index="3"
              style="font-size:16px"
            >
              已支付
              <span style="color:#FF3200">{{wait_count}}</span>
            </el-menu-item>
            <el-menu-item
              index="4"
              style="font-size:16px"
            >已完成</el-menu-item>
            <el-menu-item
              index="5"
              style="font-size:16px"
            >已作废</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <component :is="currentComponent" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AllOrder from './AllOrder';
import PendingPay from './PendingPay';
import Pay from './Pay';
import Finish from './Finish';
import Cancel from './Cancel';
import marketing from '../../../api/marketing';
export default {
  data() {
    return {
      activeIndex: '1',
      active: '1',
      wait_count: ''
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return AllOrder;
        case '2':
          return PendingPay;
        case '3':
          return Pay;
        case '4':
          return Finish;
        case '5':
          return Cancel;
        default:
          return AllOrder;
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    }
  },
  created() {
    let data = {
      order_status: 2
    };
    marketing.getProductOrders(data).then((res) => {
      if (res.code == 0) {
        if (res.data.wait_count) {
          this.wait_count = '(' + res.data.wait_count + '待完成)';
        } else {
          this.wait_count = '';
        }
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;

  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
